var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5642 1.77877L13.2562 5.16277C13.4842 5.63077 14.0962 6.07477 14.6122 6.17077L17.6722 6.67477C19.6282 6.99877 20.0842 8.41477 18.6802 9.83077L16.2922 12.2188C15.8962 12.6148 15.6682 13.3948 15.8002 13.9588L16.4842 16.9108C17.0242 19.2388 15.7762 20.1508 13.7242 18.9268L10.8562 17.2228C10.3402 16.9108 9.47622 16.9108 8.96022 17.2228L6.09222 18.9268C4.04022 20.1388 2.79222 19.2388 3.33222 16.9108L4.01622 13.9588C4.12422 13.3828 3.89622 12.6028 3.50022 12.2068L1.11222 9.81877C-0.291781 8.41477 0.16422 6.99877 2.12022 6.66277L5.18022 6.15877C5.69622 6.07477 6.30822 5.61877 6.53622 5.15077L8.22822 1.76677C9.15222 -0.0572276 10.6402 -0.0572279 11.5642 1.77877Z",
    fill: "#A0AAB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarEmpty);
export default __webpack_public_path__ + "static/media/ic_star_empty.d6e1952cac7805120d52fcd59443fac1.svg";
export { ForwardRef as ReactComponent };